export const NAME = 'policyOverview';

export const feToBeMap = {
	surname: 'surname',
	firstName: 'firstName',
	dayBirthFrom: 'policyHolderAnnualBirthDateFrom',
	dayBirthTo: 'policyHolderAnnualBirthDateTo',
	businessName: 'businessName',
	businessIn: 'businessIn',
	birthYearFrom: 'policyHolderBirthDateYearFrom',
	birthYearTo: 'policyHolderBirthDateYearTo',
	policyNumber: 'policyNo',
	policyStatus: 'policyState',
	productDomain: 'policyProductDomainId',
	policyHolderNumber: 'sellerIns',
	policyOpenDateFrom: 'policyOpenDateFrom',
	policyOpenDateTo: 'policyOpenDateTo',
	policyValueDateFrom: 'policyValueDateFrom',
	policyValueDateTo: 'policyValueDateTo',
	policyFinalDateFrom: 'policyFinalDateFrom',
	policyFinalDateTo: 'policyFinalDateTo',
	product: 'productLineTypeId',
	dayMonthInsuranceFrom: 'policyValueDateAnnualFrom',
	dayMonthInsuranceTo: 'policyValueDateAnnualTo',
	dayMonthPolicyOpenFrom: 'policyOpenDateAnnualFrom',
	dayMonthPolicyOpenTo: 'policyOpenDateAnnualTo',
	zipCode: 'policyHolderZipCode',
	semaphore: 'lastCommunicationAgeId',
	rsNumber: 'policyFrameworkNo',
	policyPaymentStatus: 'firstPaymentState',
	municipality: 'policyHolderMunicipality',
	withSubordinates: 'searchAcrossSubordinates',
};

export const numericFields = ['policyNumber', 'birthYearFrom', 'birthYearTo', 'sellerIns', 'policyState'];

export const dialogs = {
	requiredFields: `${NAME}/requiredFields`,
	tooManyResults: `${NAME}/tooManyResults`,
	tooManyResults408: `${NAME}/tooManyResults408`,
	subsellerLoginAgencyNoAndWithSubordinatesConflict: `${NAME}/subsellerLoginAgencyNoAndWithSubordinatesConflict`,
	subsellerNotFound: `${NAME}/subsellerNotFound`,
	atLeastOneContractTypeCheckboxSelected: `${NAME}/atLeastOneContractTypeCheckboxSelected`,
};

export const beDateKeys = [
	'policyOpenDateFrom',
	'policyOpenDateTo',
	'policyValueDateFrom',
	'policyValueDateTo',
	'policyFinalDateFrom',
	'policyFinalDateTo',
];
export const beDateLikeFieldsKeys = [
	'policyHolderAnnualBirthDateFrom',
	'policyHolderAnnualBirthDateTo',
	'policyOpenDateAnnualFrom',
	'policyOpenDateAnnualTo',
	'policyValueDateAnnualFrom',
	'policyValueDateAnnualTo',
];

export const checkboxFields = [
	'gcpContractsOnly',
	'gpContractsOnly',
	'frameworkPolicyOnly',
	'activePolicyWoQuotationOnly',
	'withSubordinates',
];

export const CP = '01';
export const GP = '08';

export const PPZ_SUBORDINATE_ROLE_CODE = 7;

export const sellerInCPLength = 9;
export const timeout = 408;

export const advancedSearchModalFields = [
	'municipality',
	'zipCode',
	'semaphore',
	'rsNumber',
	'carRegNo',
	'policyValueDateFrom',
	'policyValueDateTo',
	'policyOpenDateFrom',
	'policyOpenDateTo',
	'policyFinalDateFrom',
	'policyFinalDateTo',
	'policyHolderNumber',
	'sellerLogin',
	'policyHolderAnnualBirthDateFrom',
	'policyHolderAnnualBirthDateTo',
	'birthYearFrom',
	'birthYearTo',
];

export const formDataFieldsMap = {
	firstName: 'Jméno',
	surname: 'Příjmení',
	businessName: 'Název',
	personIn: 'IČO',
	policyNumber: 'Číslo PS',
	policyStatus: 'Stav PS',
	productDomain: 'Produktová oblast',
	product: 'Produkt',
	policyValueDateAnnualFrom: 'Výročí počátku od',
	policyValueDateAnnualTo: 'Výročí počátku do',
	policyOpenDateAnnualFrom: 'Výročí sjednání od',
	policyOpenDateAnnualTo: 'Výročí sjednání do',
	policyPaymentStatus: 'Stav první platby',
	gcpContractsOnly: 'PS - GČP',
	gpContractsOnly: 'PS - GP',
	frameworkPolicyOnly: 'Rámcové smlouvy',

	municipality: 'Obec',
	zipCode: 'PSČ',
	semaphore: 'Semafor',
	policyHolderAnnualBirthDateFrom: 'Den a měsíc narození od',
	policyHolderAnnualBirthDateTo: 'Den a měsíc narození do',
	birthYearFrom: 'Rok narození od',
	birtYearTo: 'Rok narození do',
	rsNumber: 'Číslo RS',
	carRegNo: 'RZ',
	policyValueDateFrom: 'Počátek platnosti od',
	policyValueDateTo: 'Počátek platnosti do',
	policyOpenDateFrom: 'Sjednaní PS od',
	policyOpenDateTo: 'Sjednaní PS do',
	policyFinalDateFrom: 'Ukončení platnosti od',
	policyFinalDateTo: 'Ukončení platnosti do',
	policyHolderNumber: 'Získatelské číslo správce',
	subordinateLogin: 'Login podobchodníka',
};

export const SUBSELLER_NOT_FOUND_ERROR_MSG = 'Podobchodník nebyl nalezen.';
